
import { SocialVideo } from '../types';

const STORAGE_KEY = 'lynqar_social_videos';

export const socialCommerceService = {
  getStoreVideos: (storeId: string): SocialVideo[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: SocialVideo[] = data ? JSON.parse(data) : [];
    return all.filter(v => v.storeId === storeId);
  },

  getProductVideos: (productId: string): SocialVideo[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: SocialVideo[] = data ? JSON.parse(data) : [];
    return all.filter(v => v.productId === productId && v.status === 'ACTIVE');
  },

  saveVideo: (video: SocialVideo) => {
    const data = localStorage.getItem(STORAGE_KEY);
    let all: SocialVideo[] = data ? JSON.parse(data) : [];
    const idx = all.findIndex(v => v.id === video.id);
    if (idx !== -1) all[idx] = video;
    else all.push(video);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  },

  deleteVideo: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: SocialVideo[] = JSON.parse(data);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all.filter(v => v.id !== id)));
  },

  trackView: (id: string) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: SocialVideo[] = JSON.parse(data);
    const updated = all.map(v => v.id === id ? { ...v, views: v.views + 1 } : v);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  },

  trackInteraction: (id: string, type: 'like' | 'share' | 'conversion') => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return;
    const all: SocialVideo[] = JSON.parse(data);
    const updated = all.map(v => {
      if (v.id === id) {
        if (type === 'like') return { ...v, likes: v.likes + 1 };
        if (type === 'share') return { ...v, shares: v.shares + 1 };
        if (type === 'conversion') {
           const newCount = (v.views * (v.conversionRate / 100)) + 1;
           return { ...v, conversionRate: (newCount / v.views) * 100 };
        }
      }
      return v;
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  }
};
